import React, {useEffect, useState} from 'react';
import cloneDeep from 'lodash/cloneDeep';
import {StorageObject} from '../../../models/StorageObject';
import {DisclaimerDTO} from '../../../models/dto/DisclaimerDTO';
import {LabelDTO} from '../../../models/dto/LabelDTO';
import {StorageObjectDTO} from '../../../models/dto/StorageObjectDTO';
import {FileMetaDataDialog} from './FileMetaDataDialog';
import {generateIdentifier} from '../../../utils/IdentityUtils';

export interface EditFileDialogProps {
    readonly item: StorageObject;
    readonly currentPath: string;
    readonly rolesDataSource: string[];
    readonly parentOwnerRoles: string[];
    readonly parentRoles: string[];
    readonly parentLocales: string[];
    readonly language: string;
    readonly defaultLocale: string;
    readonly disclaimerData: DisclaimerDTO[];
    readonly labelData: LabelDTO[];
    onClose: () => void;
    onSave: (storageObjectDTO: StorageObjectDTO, thumbnail: File | null, addMore: boolean) => void;
}

export const EditFileDialog: React.VFC<EditFileDialogProps> = (props) => {
    const [editedItem, setEditedItem] = useState<StorageObject | null>(props.item ? cloneDeep(props.item) : null);

    useEffect(() => {
        if (props.item) {
            setEditedItem(cloneDeep(props.item));
        } else {
            setEditedItem(null);
        }
    }, [props.item]);

    const handleOnSave = (storageObjectDTO: StorageObjectDTO, thumbnail: File | null, addMore: boolean) => {
        props.onSave(storageObjectDTO, thumbnail, addMore);
    };

    const renderDialog = () => {
        return (
            <FileMetaDataDialog item={editedItem}
                                file={null}
                                currentPath={props.currentPath}
                                parentOwnerRoles={props.parentOwnerRoles}
                                parentRoles={props.parentRoles}
                                parentLocales={props.parentLocales}
                                language={props.language}
                                defaultLocale={props.defaultLocale}
                                disclaimerData={props.disclaimerData}
                                labelData={props.labelData}
                                rolesDataSource={props.rolesDataSource}
                                onClose={props.onClose}
                                onSave={handleOnSave}/>
        );
    };

    return <div id={generateIdentifier()}>{renderDialog()}</div>;
};
